import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css';
Vue.use(Vuetify)

const opts = {
    // theme: { disable: true }
}

export default new Vuetify(opts);

// old connection vuetyfi



// import Vue from 'vue';
// import '@mdi/font/css/materialdesignicons.css';
//
// import Vuetify, {
//     VSnackbar
// } from 'vuetify/lib'
//
//
// Vue.use(Vuetify, {
//     components: {
//         VSnackbar
//     }
// });
//
// import ru from 'vuetify/es5/locale/ru';
// import en from 'vuetify/es5/locale/en';
//
// const opts = {
//     theme: {
//         dark: false,
//         themes: {
//             light: {
//                 primary: '#607D8B', // #E53935
//             },
//         }
//     },
//     icons: {
//         iconfont: 'mdi',
//     },
//     lang: {
//         locales: { ru, en },
//         current: 'ru'
//     }
//     // lang: {
//     //     t: (key, ...params) => i18n.t(key, params),
//     // }
// };
//
// export default new Vuetify(opts);
